export default {
  gdl: {
    gdl_data_table: {
      select: 'Sélectionner',
      sort: 'Trier',
      show_deleted: 'Montrer les lignes effacés',
    },
  },
};
